export default {
  notice_title: {
    presence: { allowEmpty: false, message: '请填写公告标题' }
  },
  notice_body: {
    presence: { allowEmpty: false, message: '请填写公告内容' }
  }
};
